import { useAuth0 } from '@auth0/auth0-react';
import { createFileRoute, useLocation, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { z } from 'zod';

import { useUser } from '@/hooks/useUser';
import { searchParam } from '@/utils/router';

const homeViewSchema = z.object({
  invitation: searchParam().optional(),
  organization: searchParam().optional(),
  organization_name: searchParam().optional(),
});

export const Route = createFileRoute('/')({
  component: Home,
  validateSearch: homeViewSchema,
});

function Home() {
  const navigate = useNavigate();
  const location = useLocation();
  const { organizationName } = useUser();
  const { isLoading } = useAuth0();

  useEffect(() => {
    // Check the path because it's possible this component is rendered
    // while Auth0 is in the middle of redirecting the user.
    if (organizationName && !isLoading && location.pathname === '/') {
      navigate({ to: `/${organizationName}`, params: { organizationName } });
    }
  }, [organizationName, navigate, isLoading, location.pathname]);

  return null;
}
